import React from "react";
import { Col, Row } from "antd";
import BoxSectionItem, { IBoxSectionItemProps } from "../box-section-item";

interface IProps {
  items: Array<IBoxSectionItemProps>;
  columnNumber: number;
}

const BoxSectionList = ({ items = [], columnNumber = 2 }: Partial<IProps>) => {
  const columnOffset = 24 / columnNumber;

  return (
    <Row gutter={[32, 0]}>
      {items.map((record, index) => (
        <Col key={index} span={columnOffset} xs={24} md={12} xl={columnOffset}>
          <BoxSectionItem {...record} />
        </Col>
      ))}
    </Row>
  );
};

export default BoxSectionList;
